/*
  globals moment
*/
(function(angular) {
  'use strict';

  var app = angular.module('asSecureCommerce');

  app.directive('datetimePicker', function() {
    /**
     * Get time in milliseconds
     *
     * @param {int} utcMilliseconds from 1970-01-01 00:00:00
     * @return {int}
     */
    var extractTime = function(utcMilliseconds) {
      return moment
        .utc(utcMilliseconds)
        .year(1970)
        .month(0)
        .date(1)
        .valueOf();
    };

    /**
     * Get date in milliseconds
     *
     * @param {int} utcMilliseconds
     * @return {int}
     */
    var extractDate = function(utcMilliseconds) {
      return moment
        .utc(utcMilliseconds)
        .hour(0)
        .minute(0)
        .second(0)
        .milliseconds(0)
        .valueOf();
    };

    /**
     * Check if number is defined
     *
     * @param value
     * return bool
     */
    var isValid = function(value) {
      return typeof value === 'number' && (value === 0 || value);
    };

    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/app/modules/secure_commerce/static/tpl/datetime-picker.html',
      scope: {
        ngModel: '=',
        min: '=',
        max: '=',
        timezone: '=',
        disabled: '=',
        dateTitle: '=',
        timeTitle: '=',
        required: '@',
        name: '@',
        infoMsg: '@',
        defaultTime: '@', // leave empty if default time is NOW
      },
      link: function($scope, $element, $attrs) {
        $scope.wasInitialised = false;
        $scope.timezoneOffset = 0;

        $scope.maxInvalid = false;
        $scope.minInvalid = false;

        if ($scope.timezone) {
          var res = $scope.timezone.split('=');
          if (res.length) {
            $scope.timezoneOffset = parseInt(res[0]);
          }
        }

        if ($scope.disabled) {
          $scope.titleDate = 'Date can not be changed';
          $scope.titleTime = 'Time can not be changed';
        } else {
          $scope.titleDate = $scope.titleTime = '';
        }

        const dateTimeFormat = 'MMM DD, YYYY HH:mm';
        const dateFormat = 'ddd, MMM DD, YYYY';
        const timeFormat = 'HH:mm';
        const pickerFormat = 'YYYY-MM-DD'; // format string for the picker;

        $scope.pickerDate = undefined;
        $scope.displayDate = undefined;

        var min = null;
        var max = null;
        var defaultTime = null;

        var $date = $($element[0]).find('input[name="date-calendar"]');
        var $time = $($element[0]).find('input[name="time-display"]');

        $scope.invalid = false;

        /**
         * DEFAULT TIME
         */
        var momentDefaultTime = 0;
        if ($scope.defaultTime) {
          momentDefaultTime = moment.utc($scope.defaultTime, timeFormat);
        } else {
          momentDefaultTime = moment
            .utc()
            .subtract($scope.timezoneOffset)
            .seconds(0)
            .milliseconds(0);
        }
        defaultTime = printDateTimeFormatted(
          extractTime(momentDefaultTime.valueOf()),
          timeFormat
        );

        /**
         * TIMEZONE
         */
        $scope.$watch('timezone', function(newVal) {
          if (!newVal) {
            return;
          }

          var res = newVal.split('=');
          if (res.length) {
            var oldOffset = $scope.timezoneOffset;
            $scope.timezoneOffset = parseInt(res[0]);
            var offsetShift = oldOffset - $scope.timezoneOffset;
            $scope.ngModel -= offsetShift;

            if (isValid($scope.min)) {
              var minToPrint = $scope.min - $scope.timezoneOffset;
              $scope.minDisplay = printDateTimeFormatted(
                minToPrint,
                dateTimeFormat
              );
              $date
                .data('DateTimePicker')
                .minDate(moment.utc(minToPrint).format(pickerFormat));
            }

            if (isValid($scope.max)) {
              var maxToPrint = $scope.max - $scope.timezoneOffset;
              $scope.maxDisplay = printDateTimeFormatted(
                maxToPrint,
                dateTimeFormat
              );
              $date
                .data('DateTimePicker')
                .maxDate(moment.utc(maxToPrint).format(pickerFormat));
            }
          }
        });

        /**
         * MIN TIME
         */
        $scope.$watch('min', function(newVal) {
          console.log('Min watched. New min: ' + newVal);
          console.log('$scope.ngModel: ' + $scope.ngModel);
          console.log('$scope.minInvalid: ' + $scope.minInvalid);
          console.log('Old min: ' + min);

          if (newVal) {
            min = newVal;
            var minToPrint = min - $scope.timezoneOffset;
            $scope.minDisplay = printDateTimeFormatted(
              minToPrint,
              dateTimeFormat
            );

            $date
              .data('DateTimePicker')
              .minDate(moment.utc(minToPrint).format(pickerFormat));

            if (
              $scope.minInvalid || // if already invalidated, we still need to update the datetime in error message
              ($scope.ngModel && min > $scope.ngModel)
            ) {
              console.log('$scope.ngModel < min. $scope.ngModel = undefined; $scope.minInvalid = true');
              $scope.ngModel = undefined;
              $scope.displayDate = '';
              $scope.invalid =
                'Min. Date: ' +
                printDateTimeFormatted(minToPrint, dateTimeFormat);
              $scope.minInvalid = true;
            }
          } else {
            min = null;
          }
        });

        /**
         * MAX TIME
         */
        $scope.$watch('max', function(newVal) {
            console.log('Max watched. New max: ' + newVal);
            console.log('$scope.ngModel: ' + $scope.ngModel);
            console.log('$scope.maxInvalid: ' + $scope.maxInvalid);
            console.log('Old max: ' + max);

            if (newVal) {
            max = newVal;
            var maxToPrint = max - $scope.timezoneOffset;

            if ($scope.min && newVal < $scope.min) {
              // max can not be less than min
              max = null;
              return;
            }

            $scope.maxDisplay = printDateTimeFormatted(
              maxToPrint,
              dateTimeFormat
            );
            $date
              .data('DateTimePicker')
              .maxDate(moment.utc(maxToPrint).format(pickerFormat));

            if ($scope.maxInvalid || ($scope.ngModel && max < $scope.ngModel)) {
              $scope.ngModel = undefined;
              $scope.displayDate = '';
              $scope.maxInvalid = true;
              $scope.invalid =
                'Max. Date: ' +
                printDateTimeFormatted(maxToPrint, dateTimeFormat);
            }
          } else {
            max = null;
          }
        });

        /**
         * Angular init
         */
        $scope.$watch('ngModel', function(newVal) {
            console.log('ngModel watched. New ngModel: ' + newVal);
            console.log('$scope.wasInitialised: ' + $scope.wasInitialised);

          if (!isValid(newVal) && !$scope.wasInitialised) {
            // first init
            $scope.timeDisplay = defaultTime;
            $scope.wasInitialised = true;

            return;
          } else if (!isValid(newVal) && $scope.wasInitialised) {
            return;
          }

          var newValOffset = moment.tz.zone(window.tz).utcOffset(newVal) * 60 * 1000;
          var datetimeToPrint = newVal - newValOffset;
          $scope.pickerDate = printDateTimeFormatted(
            extractDate(datetimeToPrint),
            pickerFormat
          );
          $scope.displayDate = printDateTimeFormatted(
            extractDate(datetimeToPrint),
            dateFormat
          );
          $scope.timeDisplay = printDateTimeFormatted(
            extractTime(datetimeToPrint),
            timeFormat
          );
        });

        function printDateTimeFormatted(
          utcDateTimeMilliseconds,
          displayFormat
        ) {
          if (!isValid(utcDateTimeMilliseconds)) {
            return '';
          }

          return moment.utc(utcDateTimeMilliseconds).format(displayFormat);
        }

        function getUserInputInUtcMilliseconds() {
          var userDate = $date.val();
          var userTime = $time.val();

          if (!userTime.match(/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)) {
            return -1;
          } else if (!userDate || !userTime) {
            return 0;
          }

          var ts = moment.utc(userDate + ' ' + userTime, pickerFormat + ' ' + timeFormat);
          var tsOffset = moment.tz.zone(window.tz).utcOffset(ts) * 60 * 1000;

          return moment(ts).add(tsOffset).valueOf();
        }

        function validate(utcDateTimeMilliseconds) {
          if (utcDateTimeMilliseconds === 0) {
            $scope.invalid = undefined; // some inputs are empty - nothing to do here
            $scope.maxInvalid = false;
            $scope.minInvalid = false;

            return false;
          } else if (utcDateTimeMilliseconds === -1) {
            $scope.invalid = 'Please enter a valid time';
            $scope.maxInvalid = false;
            $scope.minInvalid = false;

            return false;
          } else if (min && min > utcDateTimeMilliseconds) {
            $scope.invalid =
              'Min. Date: ' +
              printDateTimeFormatted(
                min - $scope.timezoneOffset,
                dateTimeFormat
              );
            $scope.minInvalid = true;

            return false;
          } else if (max && max < utcDateTimeMilliseconds) {
            $scope.invalid =
              'Max. Date: ' +
              printDateTimeFormatted(
                max - $scope.timezoneOffset,
                dateTimeFormat
              );
            $scope.maxInvalid = true;

            return false;
          }

          $scope.invalid = undefined;
          $scope.maxInvalid = false;
          $scope.minInvalid = false;

          return true;
        }

        function userActionHandler() {
          var utcMilliseconds = getUserInputInUtcMilliseconds();

          if (validate(utcMilliseconds)) {
            $scope.ngModel = utcMilliseconds;
          } else {
            $scope.ngModel = undefined;
          }

          $scope.$apply();
        }

        $date
          .datetimepicker({
            format: pickerFormat,
            useCurrent: false,
            ignoreReadonly: true,
            debug: false,
          })
          .on('dp.change', function(event) {
            var momentDate = moment.utc($date.val(), pickerFormat).format();

            $scope.displayDate = printDateTimeFormatted(
              extractDate(momentDate.valueOf()),
              dateFormat
            );
            userActionHandler();
          });

        $time.on('change', userActionHandler);
      },
    };
  });
})(window.angular);
